<mat-card class="card">
    <card-header title="{{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.TITLE' | translate }}">
        <button mat-flat-button (click)="addNewRecord()" color="primary" *ngIf="!isAssociate" [disabled]="subject?.serviceProviderStatus === 'PASSIVE'">
            {{ 'NEW_SUBJECT_RECORD.TITLE' | translate }}
        </button>
    </card-header>
    <div class="table-responsive-wrapper" *ngIf="page.content.length > 0">
        <table mat-table [dataSource]="page.content" #mytable class="records-table">
            <ng-container matColumnDef="providedService">
                <th mat-header-cell *matHeaderCellDef>{{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.PROVIDED_SERVICE' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.providedService.title }}</td>
            </ng-container>

            <ng-container matColumnDef="rightGrantedDate">
                <th mat-header-cell *matHeaderCellDef>{{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.RIGHT_GRANTED_DATE' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.rightGrantedDate | date:'dd.MM.yyyy.' }}</td>
            </ng-container>

            <ng-container matColumnDef="outcomeStatus">
                <th mat-header-cell *matHeaderCellDef>{{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.OUTCOME_STATUS' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.outcomeStatus?.label }}</td>
            </ng-container>

            <ng-container matColumnDef="realizationStartDate">
                <th mat-header-cell *matHeaderCellDef>{{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.REALIZATION_START_DATE' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.realizationStartDate | date:'dd.MM.yyyy.' }}</td>
            </ng-container>

            <ng-container matColumnDef="realizationEndDate">
                <th mat-header-cell *matHeaderCellDef>{{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.REALIZATION_END_DATE' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.realizationEndDate | date:'dd.MM.yyyy.' }}</td>
            </ng-container>

            <ng-container matColumnDef="rightEndDate">
                <th mat-header-cell *matHeaderCellDef>{{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.RIGHT_END_DATE' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.rightEndDate | date:'dd.MM.yyyy.' }}</td>
            </ng-container>

            <ng-container matColumnDef="monthlyPrice">
                <th mat-header-cell *matHeaderCellDef>{{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.MONTHLY_PRICE' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.monthlyPrice }}</td>
            </ng-container>

            <ng-container matColumnDef="paymentMethod">
                <th mat-header-cell *matHeaderCellDef>{{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.PAYMENT_METHOD' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.paymentMethod.title }}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" class="table__cell table__cell--align-right">
                <button
                    mat-icon-button
                    class="button-square table__row-button"
                    color="primary"
                    [disabled]="subject?.serviceProviderStatus === 'PASSIVE'"
                    [matTooltip]="!element.licenceValid 
                        ? ('SERVICE_PROVIDERS.SUBJECT_RECORD.SUSPENDED_LICENCE' | translate) 
                        : ('SUBJECTS.MORE_TOOLTIP' | translate)"
                    [matMenuTriggerFor]="menu"
                    (click)="$event.stopPropagation()"> <mat-icon class="button-square__icon">more_horiz</mat-icon>
                </button>
                <mat-menu #menu="matMenu" class="filter-menu">
                    <button mat-menu-item (click)="handleEditDialog(element)" [disabled]="!element.licenceValid">
                        <mat-icon class="button-square__icon">edit</mat-icon>
                        {{ 'SUBJECT_PROBLEMS.TABLE.EDIT_PROBLEM' | translate }}
                    </button>
                    <button mat-menu-item (click)="handleDeleteDialog(element)">
                        <mat-icon class="button-square__icon">delete</mat-icon>
                        {{ 'SUBJECT_PROBLEMS.TABLE.DELETE_PROBLEM' | translate }}
                    </button>
                </mat-menu>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.disabled-row]="!row.licenceValid" class="records-table__row"></tr>
        </table>
    </div>
    <div class="pagination" *ngIf="page.content.length > 0">
       <app-custom-pagination
          [page]="page"
          (firstPageEvent)="getFirstPage()"
          (previousPageEvent)="getPreviousPage()"
          (nextPageEvent)="getNextPage()"
          (lastPageEvent)="getLastPage()"
          (pageSizeEvent)="getPageInNewSize($event)"
       ></app-custom-pagination>
    </div>
    <p class="records-empty" *ngIf="page.content.length === 0">
       <mat-icon class="records-empty__icon">info</mat-icon>
       {{ 'SERVICE_PROVIDERS.SUBJECT_RECORD.NO_RESULTS' | translate }}
    </p>
</mat-card>
 